import { render, staticRenderFns } from "./LffLanding.vue?vue&type=template&id=c8510a4a&"
import script from "./LffLanding.vue?vue&type=script&lang=js&"
export * from "./LffLanding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports